export const getUserArea = ({ state }) => state.userLocationReducer.area;
export const getUserAddress = ({ state }) => state.userLocationReducer.address;
export const getUserTempAddress = ({ state }) =>
  state.userLocationReducer.tempAddress;
export const getCountryIdByAddress = ({ state }) =>
  state.userLocationReducer.countryId;
export const getAreaId = ({ state }) => state.userLocationReducer.areaId;
